module.exports = __webpack_public_path__ + "static/22-3b5743e49e59d8e83af0debd85fd5daf.jpg";